export const languagesData = [
  { text: "Spanish", link: "/spanish-translation.php" },
  { text: "French", link: "/french-translation.php" },
  { text: "Arabic", link: "/arabic-translation.php" },
  { text: "German", link: "/german-translation.php" },
  { text: "Italian", link: "/italian-translation.php" },
  { text: "Japanese", link: "/japanese-translation.php" },
  { text: "Korean", link: "/korean-translation.php" },
  { text: "Chinese", link: "/chinese-translation.php" },
  { text: "Portuguese", link: "/portuguese-translation.php" },
  { text: "Dutch", link: "/dutch-translation.php" },
  { text: "Czech", link: "/czech-translation.php" },
  { text: "Greek", link: "/greek-translation.php" },
  { text: "Thai", link: "/thai-translation.php" },
  { text: "Turkish", link: "/turkish-translation.php" },
  { text: "Polish", link: "/polish-translation.php" },
  { text: "Hungarian", link: "/hungarian-translation.php" },
  { text: "Norwegian", link: "/norwegian-translation.php" },
  { text: "Swedish", link: "/swedish-translation.php" },
  { text: "Vietnamese", link: "/vietnamese-translation.php" },
  { text: "Hindi", link: "/hindi-translation.php" },
  { text: "Bengali", link: "/bengali-translation.php" },
  { text: "Malay", link: "/malay-translation.php" },
  { text: "Persian", link: "/persian-translation.php" },
  { text: "Ukrainian", link: "/ukrainian-translation.php" },
  { text: "Danish", link: "/danish-translation.php" },
  { text: "Irish", link: "/irish-translation.php" },
  { text: "Romanian", link: "/romanian-translation.php" },
  { text: "Albanian", link: "/albanian-translation.php" },
  { text: "Armenian", link: "/armenian-translation.php" },
  { text: "Estonian", link: "/estonian-translation.php" },
  { text: "Finnish", link: "/finnish-translation.php" },
  { text: "Bulgarian", link: "/bulgarian-translation.php" },
  { text: "Latvian", link: "/latvian-translation.php" },
  { text: "Croatian", link: "/croatian-translation.php" },
  { text: "Lithuanian", link: "/lithuanian-translation.php" },
  { text: "Maltese", link: "/maltese-translation.php" },
  { text: "Slovak", link: "/slovak-translation.php" },
  { text: "Slovenian", link: "/slovenian-translation.php" },
  { text: "Welsh", link: "/welsh-translation.php" },
  { text: "Yiddish", link: "/yiddish-translation.php" },
  { text: "Serbian", link: "/serbian-translation.php" },
  { text: "Sorbian", link: "/sorbian-translation.php" },
  { text: "Bosnian", link: "/bosnian-translation.php" },
  { text: "Icelandic", link: "/icelandic-translation.php" },
  { text: "Elfdalian", link: "/elfdalian-translation.php" },
  { text: "Macedonian", link: "/macedonian-translation.php" },
  { text: "Occitan", link: "/occitan-translation.php" },
  { text: "Afrikaans", link: "/afrikaans-translation.php" },
  { text: "Filipino", link: "/filipino-translation.php" },
  { text: "Amharic", link: "/amharic-translation.php" },
  { text: "Twitter", link: "/twitter-translation.php" },
  { text: "Azerbaijani", link: "/azerbaijani-translation.php" },
  { text: "Legal", link: "/legal-translation.php" },
  { text: "Belarusian", link: "/belarusian-translation.php" },
  { text: "Burmese", link: "/burmese-translation.php" },
  { text: "Uzbek", link: "/uzbek-translation.php" },
  { text: "Kurdish", link: "/kurdish-translation.php" },
  { text: "Uzbek", link: "/uzbek-translation.php" },
  { text: "Tigrinya", link: "/tigrinya-translation.php" },
  { text: "Swahili", link: "/swahili-translation.php" },
  { text: "Gujarati", link: "/gujarati-translation.php" },
  { text: "Kannada", link: "/kannada-translation.php" },
  { text: "Malayalam", link: "/malayalam-translation.php" },
  { text: "Nepali", link: "/nepali-translation.php" },
  { text: "Marathi", link: "/marathi-translation.php" },
  { text: "Pashto", link: "/pashto-translation.php" },
  { text: "Punjabi", link: "/punjabi-translation.php" },
  { text: "Sinhalese", link: "/sinhalese-translation.php" },
  { text: "Philippine", link: "/philippine-translation.php" },
  { text: "Somali", link: "/somali-translation.php" },
  { text: "Bahasa", link: "/bahasa-translation.php" },
  { text: "Catalan", link: "/catalan-translation.php" },
  { text: "Galician", link: "/galician-translation.php" },
  { text: "Georgian", link: "/georgian-translation.php" },
  { text: "Abkhazian", link: "/abkhazian-translation.php" },
  { text: "Aymara", link: "/aymara-translation.php" },
  { text: "Bashkir", link: "/bashkir-translation.php" },
  { text: "Basque", link: "/basque-translation.php" },
  { text: "Berber", link: "/berber-translation.php" },
  { text: "Dzongkha", link: "/dzongkha-translation.php" },
  { text: "Cambodian", link: "/cambodian-translation.php" },
  { text: "Cherokee", link: "/cherokee-translation.php" },
  { text: "Chewa", link: "/chewa-translation.php" },
  { text: "Chuukese", link: "/chuukese-translation.php" },
  { text: "Corsican", link: "/corsican-translation.php" },
  { text: "Divehi", link: "/divehi-translation.php" },
  { text: "Faroese", link: "/faroese-translation.php" },
  { text: "Assamese", link: "/assamese-translation.php" },
  { text: "Esperanto", link: "/esperanto-translation.php" },
  { text: "Fijian", link: "/fijian-translation.php" },
  { text: "Flemish", link: "/flemish-translation.php" },
  { text: "Frisian", link: "/frisian-translation.php" },
  { text: "Fula", link: "/fula-translation.php" },
  { text: "Greenlandic", link: "/greenlandic-translation.php" },
  { text: "Guarani", link: "/guarani-translation.php" },
  { text: "Haitian-creole", link: "/haitian-creole-translation.php" },
  { text: "Hausa", link: "/hausa-translation.php" },
  { text: "Hawaiian", link: "/hawaiian-translation.php" },
  { text: "Hmong", link: "/hmong-translation.php" },
  { text: "Ibibio", link: "/ibibio-translation.php" },
  { text: "Igbo", link: "/igbo-translation.php" },
  { text: "Interlingua", link: "/interlingua-translation.php" },
  { text: "Inuktitut", link: "/inuktitut-translation.php" },
  { text: "Inupiaq", link: "/inupiaq-translation.php" },
  { text: "Javanese", link: "/javanese-translation.php" },
  { text: "Kanuri", link: "/kanuri-translation.php" },
  { text: "Kashmiri", link: "/kashmiri-translation.php" },
  { text: "Kirghiz", link: "/kirghiz-translation.php" },
  { text: "Konkani", link: "/konkani-translation.php" },
  { text: "Laothian", link: "/laothian-translation.php" },
  { text: "Malagasy", link: "/malagasy-translation.php" },
  { text: "Lingala", link: "/lingala-translation.php" },
  { text: "Maori", link: "/maori-translation.php" },
  { text: "Moldavian", link: "/moldavian-translation.php" },
  { text: "Mongolian", link: "/mongolian-translation.php" },
  { text: "Nauru", link: "/nauru-translation.php" },
  { text: "Oriya", link: "/oriya-translation.php" },
  { text: "Oromo", link: "/oromo-translation.php" },
  { text: "Papiamentu", link: "/papiamentu-translation.php" },
  { text: "Quechua", link: "/quechua-translation.php" },
  { text: "Sami", link: "/sami-translation.php" },
  { text: "Samoan", link: "/samoan-translation.php" },
  { text: "Sanskrit", link: "/sanskrit-translation.php" },
  { text: "Sesotho", link: "/sesotho-translation.php" },
  { text: "Setswana", link: "/setswana-translation.php" },
  { text: "Shona", link: "/shona-translation.php" },
  { text: "Sindhi", link: "/sindhi-translation.php" },
  { text: "Hebrew", link: "/hebrew-translation.php" },
  { text: "Siswati", link: "/siswati-translation.php" },
  { text: "Sundanese", link: "/sundanese-translation.php" },
  { text: "Syriac", link: "/syriac-translation.php" },
  { text: "Tajik", link: "/tajik-translation.php" },
  { text: "Tamazight", link: "/tamazight-translation.php" },
  { text: "Tamil", link: "/tamil-translation.php" },
  { text: "Tatar", link: "/tatar-translation.php" },
  { text: "Telugu", link: "/telugu-translation.php" },
  { text: "Tibetan", link: "/tibetan-translation.php" },
  { text: "Simplified-english", link: "/simplified-english-translation.php" },
  { text: "Tsonga", link: "/tsonga-translation.php" },
  { text: "Urdu", link: "/urdu-translation.php" },
  { text: "Tongan", link: "/tongan-translation.php" },
  { text: "Twi", link: "/twi-translation.php" },
  { text: "Turkmen", link: "/turkmen-translation.php" },
  { text: "Thosa", link: "/xhosa-translation.php" },
  { text: "Tulu", link: "/zulu-translation.php" },
  { text: "Toruba", link: "/yoruba-translation.php" },
  { text: "Wolof", link: "/wolof-translation.php" },
  { text: "Slovenian", link: "/professional-slovenian-translation.php" },
  { text: "Indonesian", link: "/indonesian-translation.php" },
];

export const languagesDataMobile1 = [
  { text: "Spanish", link: "/spanish-translation.php" },
  { text: "French", link: "/french-translation.php" },
  { text: "Arabic", link: "/arabic-translation.php" },
  { text: "German", link: "/german-translation.php" },
  { text: "Italian", link: "/italian-translation.php" },
  { text: "Japanese", link: "/japanese-translation.php" },
  { text: "Korean", link: "/korean-translation.php" },
  { text: "Chinese", link: "/chinese-translation.php" },
  { text: "Portuguese", link: "/portuguese-translation.php" },
  { text: "Dutch", link: "/dutch-translation.php" },
  { text: "Czech", link: "/czech-translation.php" },
  { text: "Greek", link: "/greek-translation.php" },
  { text: "Thai", link: "/thai-translation.php" },
  { text: "Turkish", link: "/turkish-translation.php" },
  { text: "Polish", link: "/polish-translation.php" },
  { text: "Hungarian", link: "/hungarian-translation.php" },
  { text: "Norwegian", link: "/norwegian-translation.php" },
  { text: "Swedish", link: "/swedish-translation.php" },
  { text: "Vietnamese", link: "/vietnamese-translation.php" },
  { text: "Hindi", link: "/hindi-translation.php" },
  { text: "Bengali", link: "/bengali-translation.php" },
  { text: "Malay", link: "/malay-translation.php" },
  { text: "Persian", link: "/persian-translation.php" },
  { text: "Ukrainian", link: "/ukrainian-translation.php" },
  { text: "Danish", link: "/danish-translation.php" },
  { text: "Irish", link: "/irish-translation.php" },
  { text: "Romanian", link: "/romanian-translation.php" },
  { text: "Albanian", link: "/albanian-translation.php" },
  { text: "Armenian", link: "/armenian-translation.php" },
  { text: "Estonian", link: "/estonian-translation.php" },
  { text: "Finnish", link: "/finnish-translation.php" },
  { text: "Bulgarian", link: "/bulgarian-translation.php" },
  { text: "Latvian", link: "/latvian-translation.php" },
  { text: "Croatian", link: "/croatian-translation.php" },
  { text: "Lithuanian", link: "/lithuanian-translation.php" },
  { text: "Maltese", link: "/maltese-translation.php" },
  { text: "Slovak", link: "/slovak-translation.php" },
  { text: "Slovenian", link: "/slovenian-translation.php" },
  { text: "Welsh", link: "/welsh-translation.php" },
  { text: "Yiddish", link: "/yiddish-translation.php" },
  { text: "Serbian", link: "/serbian-translation.php" },
  { text: "Sorbian", link: "/sorbian-translation.php" },
  { text: "Bosnian", link: "/bosnian-translation.php" },
  { text: "Icelandic", link: "/icelandic-translation.php" },
  { text: "Elfdalian", link: "/elfdalian-translation.php" },
  { text: "Macedonian", link: "/macedonian-translation.php" },
  { text: "Occitan", link: "/occitan-translation.php" },
  { text: "Afrikaans", link: "/afrikaans-translation.php" },
  { text: "Filipino", link: "/filipino-translation.php" },
  { text: "Amharic", link: "/amharic-translation.php" },
  { text: "Twitter", link: "/twitter-translation.php" },
  { text: "Azerbaijani", link: "/azerbaijani-translation.php" },
];

export const languagesDataMobile2 = [
  { text: "Legal", link: "/legal-translation.php" },
  { text: "Belarusian", link: "/belarusian-translation.php" },
  { text: "Burmese", link: "/burmese-translation.php" },
  { text: "Uzbek", link: "/uzbek-translation.php" },
  { text: "Kurdish", link: "/kurdish-translation.php" },
  { text: "Uzbek", link: "/uzbek-translation.php" },
  { text: "Tigrinya", link: "/tigrinya-translation.php" },
  { text: "Swahili", link: "/swahili-translation.php" },
  { text: "Gujarati", link: "/gujarati-translation.php" },
  { text: "Kannada", link: "/kannada-translation.php" },
  { text: "Malayalam", link: "/malayalam-translation.php" },
  { text: "Nepali", link: "/nepali-translation.php" },
  { text: "Marathi", link: "/marathi-translation.php" },
  { text: "Pashto", link: "/pashto-translation.php" },
  { text: "Punjabi", link: "/punjabi-translation.php" },
  { text: "Sinhalese", link: "/sinhalese-translation.php" },
  { text: "Philippine", link: "/philippine-translation.php" },
  { text: "Somali", link: "/somali-translation.php" },
  { text: "Bahasa", link: "/bahasa-translation.php" },
  { text: "Catalan", link: "/catalan-translation.php" },
  { text: "Galician", link: "/galician-translation.php" },
  { text: "Georgian", link: "/georgian-translation.php" },
  { text: "Abkhazian", link: "/abkhazian-translation.php" },
  { text: "Aymara", link: "/aymara-translation.php" },
  { text: "Bashkir", link: "/bashkir-translation.php" },
  { text: "Basque", link: "/basque-translation.php" },
  { text: "Berber", link: "/berber-translation.php" },
  { text: "Dzongkha", link: "/dzongkha-translation.php" },
  { text: "Cambodian", link: "/cambodian-translation.php" },
  { text: "Cherokee", link: "/cherokee-translation.php" },
  { text: "Chewa", link: "/chewa-translation.php" },
  { text: "Chuukese", link: "/chuukese-translation.php" },
  { text: "Corsican", link: "/corsican-translation.php" },
  { text: "Divehi", link: "/divehi-translation.php" },
  { text: "Faroese", link: "/faroese-translation.php" },
  { text: "Assamese", link: "/assamese-translation.php" },
  { text: "Esperanto", link: "/esperanto-translation.php" },
  { text: "Fijian", link: "/fijian-translation.php" },
  { text: "Flemish", link: "/flemish-translation.php" },
  { text: "Frisian", link: "/frisian-translation.php" },
  { text: "Fula", link: "/fula-translation.php" },
  { text: "Greenlandic", link: "/greenlandic-translation.php" },
  { text: "Guarani", link: "/guarani-translation.php" },
  { text: "Haitian-creole", link: "/haitian-creole-translation.php" },
  { text: "Hausa", link: "/hausa-translation.php" },
  { text: "Hawaiian", link: "/hawaiian-translation.php" },
  { text: "Hmong", link: "/hmong-translation.php" },
  { text: "Ibibio", link: "/ibibio-translation.php" },
  { text: "Igbo", link: "/igbo-translation.php" },
  { text: "Interlingua", link: "/interlingua-translation.php" },
  { text: "Inuktitut", link: "/inuktitut-translation.php" },
  { text: "Inupiaq", link: "/inupiaq-translation.php" },
  { text: "Javanese", link: "/javanese-translation.php" },
  { text: "Kanuri", link: "/kanuri-translation.php" },
  { text: "Kashmiri", link: "/kashmiri-translation.php" },
  { text: "Kirghiz", link: "/kirghiz-translation.php" },
  { text: "Konkani", link: "/konkani-translation.php" },
  { text: "Laothian", link: "/laothian-translation.php" },
  { text: "Malagasy", link: "/malagasy-translation.php" },
  { text: "Lingala", link: "/lingala-translation.php" },
  { text: "Maori", link: "/maori-translation.php" },
  { text: "Moldavian", link: "/moldavian-translation.php" },
  { text: "Mongolian", link: "/mongolian-translation.php" },
  { text: "Nauru", link: "/nauru-translation.php" },
  { text: "Oriya", link: "/oriya-translation.php" },
  { text: "Oromo", link: "/oromo-translation.php" },
  { text: "Papiamentu", link: "/papiamentu-translation.php" },
  { text: "Quechua", link: "/quechua-translation.php" },
  { text: "Sami", link: "/sami-translation.php" },
  { text: "Samoan", link: "/samoan-translation.php" },
  { text: "Sanskrit", link: "/sanskrit-translation.php" },
  { text: "Sesotho", link: "/sesotho-translation.php" },
  { text: "Setswana", link: "/setswana-translation.php" },
  { text: "Shona", link: "/shona-translation.php" },
  { text: "Sindhi", link: "/sindhi-translation.php" },
  { text: "Hebrew", link: "/hebrew-translation.php" },
  { text: "Siswati", link: "/siswati-translation.php" },
  { text: "Sundanese", link: "/sundanese-translation.php" },
  { text: "Syriac", link: "/syriac-translation.php" },
  { text: "Tajik", link: "/tajik-translation.php" },
  { text: "Tamazight", link: "/tamazight-translation.php" },
  { text: "Tamil", link: "/tamil-translation.php" },
  { text: "Tatar", link: "/tatar-translation.php" },
  { text: "Telugu", link: "/telugu-translation.php" },
  { text: "Tibetan", link: "/tibetan-translation.php" },
  { text: "Simplified-english", link: "/simplified-english-translation.php" },
  { text: "Tsonga", link: "/tsonga-translation.php" },
  { text: "Urdu", link: "/urdu-translation.php" },
  { text: "Tongan", link: "/tongan-translation.php" },
  { text: "Twi", link: "/twi-translation.php" },
  { text: "Turkmen", link: "/turkmen-translation.php" },
  { text: "Thosa", link: "/xhosa-translation.php" },
  { text: "Tulu", link: "/zulu-translation.php" },
  { text: "Toruba", link: "/yoruba-translation.php" },
  { text: "Wolof", link: "/wolof-translation.php" },
  { text: "Slovenian", link: "/professional-slovenian-translation.php" },
  { text: "Indonesian", link: "/indonesian-translation.php" },
];

export const languagesPairsData = [
  { text: "English to Latin", link: "/english-to-latin-translation.php" },
  { text: "English to Icelandic", link: "/english-to-icelandic-translation-service.php" },
  { text: "Icelandic to English", link: "/icelandic-to-english-translation-service.php" },
  { text: "Bulgarian to English", link: "/bulgarian-to-english-translation-service.php" },
  { text: "Latin to English", link: "/english-to-latin-translation-service.php" },
  { text: "English to Latin", link: "/latin-to-english-translation-service.php" },
  { text: "English to Arabic", link: "/english-to-arabic-translation-service.php" },
  { text: "English to Chinese", link: "/english-to-chinese-translation-service.php" },
  { text: "English to Czech", link: "/english-to-czech-translation-service.php" },
  { text: "English to Danish", link: "/english-to-danish-translation-service.php" },
  { text: "English to Dutch", link: "/english-to-dutch-translation-service.php" },
  { text: "English to Finnish", link: "/english-to-finnish-translation-service.php" },
  { text: "English to French", link: "/english-to-french-translation-service.php" },
  { text: "English to German", link: "/english-to-german-translation-service.php" },
  { text: "English to Greek", link: "/english-to-greek-translation-service.php" },
  { text: "English to Hebrew", link: "/english-to-hebrew-translation-service.php" },
  { text: "English to Italian", link: "/english-to-italian-translation-service.php" },
  { text: "English to Korean", link: "/english-to-korean-translation-service.php" },
  { text: "English to Norwegian", link: "/english-to-norwegian-translation-service.php" },
  { text: "English to Polish", link: "/english-to-polish-translation-service.php" },
  { text: "English to Portuguese", link: "/english-to-portuguese-translation-service.php" },
  { text: "English to Japanese", link: "/english-to-japanese-translation-service.php" },
  { text: "English to Russian", link: "/english-to-russian-translation-service.php" },
  { text: "English to Spanish", link: "/english-to-spanish-translation-service.php" },
  { text: "English to Swedish", link: "/english-to-swedish-translation-service.php" },
  { text: "English to Thai", link: "/english-to-thai-translation-service.php" },
  { text: "English to Turkish", link: "/english-to-turkish-translation-service.php" },
  { text: "Arabic to English", link: "/arabic-to-english-translation-service.php" },
  { text: "Czech to English", link: "/czech-to-english-translation-service.php" },
  { text: "Chinese to English", link: "/chinese-to-english-translation-service.php" },
  { text: "Danish to English", link: "/danish-to-english-translation-service.php" },
  { text: "Dutch to English", link: "/dutch-to-english-translation-service.php" },
  { text: "Finnish to English", link: "/finnish-to-english-translation-service.php" },
  { text: "French to English", link: "/french-to-english-translation-service.php" },
  { text: "German to English", link: "/german-to-english-translation-service.php" },
  { text: "Greek to English", link: "/greek-to-english-translation-service.php" },
  { text: "Italian to English", link: "/italian-to-english-translation-service.php" },
  { text: "Japanese to English", link: "/japanese-to-english-translation-service.php" },
  { text: "Korean to English", link: "/korean-to-english-translation-service.php" },
  { text: "Polish to English", link: "/polish-to-english-translation-service.php" },
  { text: "Spanish to English", link: "/spanish-to-english-translation-service.php" },
  { text: "Norwegian to English", link: "/norwegian-to-english-translation-service.php" },
  { text: "Portuguese to English", link: "/portuguese-to-english-translation-service.php" },
  { text: "Russian to English", link: "/russian-to-english-translation-service.php" },
  { text: "Swedish to English", link: "/swedish-to-english-translation-service.php" },
  { text: "Thai to English", link: "/thai-to-english-translation-service.php" },
  { text: "Turkish to English", link: "/turkish-to-english-translation-service.php" },
  { text: "Hebrew to English", link: "/hebrew-to-english-translation-service.php" },
  { text: "English to Albanian", link: "/english-to-albanian-translation-service.php" },
  { text: "Albanian to English", link: "/albanian-to-english-translation.php" },
  { text: "English to Bulgarian", link: "/english-to-bulgarian-translation-service.php" },
  { text: "English to Croatian", link: "/english-to-croatian-translation.php" },
  { text: "Romanian to English", link: "/romanian-to-english-translation-service.php" },
  { text: "English to Romanian", link: "/english-to-romanian-translation-service.php" },
  { text: "Ukrainian to English", link: "/ukrainian-to-english-translation.php" },
];

export const languagesPairsDataMobile1 = [
  { text: "English to Latin", link: "/english-to-latin-translation.php" },
  { text: "English to Icelandic", link: "/english-to-icelandic-translation-service.php" },
  { text: "Icelandic to English", link: "/icelandic-to-english-translation-service.php" },
  { text: "Bulgarian to English", link: "/bulgarian-to-english-translation-service.php" },
  { text: "Latin to English", link: "/english-to-latin-translation-service.php" },
  { text: "English to Latin", link: "/latin-to-english-translation-service.php" },
  { text: "English to Arabic", link: "/english-to-arabic-translation-service.php" },
  { text: "English to Chinese", link: "/english-to-chinese-translation-service.php" },
  { text: "English to Czech", link: "/english-to-czech-translation-service.php" },
  { text: "English to Danish", link: "/english-to-danish-translation-service.php" },
  { text: "English to Dutch", link: "/english-to-dutch-translation-service.php" },
  { text: "English to Finnish", link: "/english-to-finnish-translation-service.php" },
  { text: "English to French", link: "/english-to-french-translation-service.php" },
  { text: "English to German", link: "/english-to-german-translation-service.php" },
  { text: "English to Greek", link: "/english-to-greek-translation-service.php" },
  { text: "English to Hebrew", link: "/english-to-hebrew-translation-service.php" },
  { text: "English to Italian", link: "/english-to-italian-translation-service.php" },
  { text: "English to Korean", link: "/english-to-korean-translation-service.php" },
  { text: "English to Norwegian", link: "/english-to-norwegian-translation-service.php" },
  { text: "English to Polish", link: "/english-to-polish-translation-service.php" },
  { text: "English to Portuguese", link: "/english-to-portuguese-translation-service.php" },
  { text: "English to Japanese", link: "/english-to-japanese-translation-service.php" },
  { text: "English to Russian", link: "/english-to-russian-translation-service.php" },
  { text: "English to Spanish", link: "/english-to-spanish-translation-service.php" },
  { text: "English to Swedish", link: "/english-to-swedish-translation-service.php" },
  { text: "English to Thai", link: "/english-to-thai-translation-service.php" },
  { text: "English to Turkish", link: "/english-to-turkish-translation-service.php" },
  { text: "Arabic to English", link: "/arabic-to-english-translation-service.php" },
  { text: "Czech to English", link: "/czech-to-english-translation-service.php" },
];

export const languagesPairsDataMobile2 = [
  { text: "Chinese to English", link: "/chinese-to-english-translation-service.php" },
  { text: "Danish to English", link: "/danish-to-english-translation-service.php" },
  { text: "Dutch to English", link: "/dutch-to-english-translation-service.php" },
  { text: "Finnish to English", link: "/finnish-to-english-translation-service.php" },
  { text: "French to English", link: "/french-to-english-translation-service.php" },
  { text: "German to English", link: "/german-to-english-translation-service.php" },
  { text: "Greek to English", link: "/greek-to-english-translation-service.php" },
  { text: "Italian to English", link: "/italian-to-english-translation-service.php" },
  { text: "Japanese to English", link: "/japanese-to-english-translation-service.php" },
  { text: "Korean to English", link: "/korean-to-english-translation-service.php" },
  { text: "Polish to English", link: "/polish-to-english-translation-service.php" },
  { text: "Spanish to English", link: "/spanish-to-english-translation-service.php" },
  { text: "Norwegian to English", link: "/norwegian-to-english-translation-service.php" },
  { text: "Portuguese to English", link: "/portuguese-to-english-translation-service.php" },
  { text: "Russian to English", link: "/russian-to-english-translation-service.php" },
  { text: "Swedish to English", link: "/swedish-to-english-translation-service.php" },
  { text: "Thai to English", link: "/thai-to-english-translation-service.php" },
  { text: "Turkish to English", link: "/turkish-to-english-translation-service.php" },
  { text: "Hebrew to English", link: "/hebrew-to-english-translation-service.php" },
  { text: "English to Albanian", link: "/english-to-albanian-translation-service.php" },
  { text: "Albanian to English", link: "/albanian-to-english-translation.php" },
  { text: "English to Bulgarian", link: "/english-to-bulgarian-translation-service.php" },
  { text: "English to Croatian", link: "/english-to-croatian-translation.php" },
  { text: "Romanian to English", link: "/romanian-to-english-translation-service.php" },
  { text: "English to Romanian", link: "/english-to-romanian-translation-service.php" },
  { text: "Ukrainian to English", link: "/ukrainian-to-english-translation.php" },
];
